import { Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './hooks/useAuthStore';
import Intro from './components/Intro';
import Login from './components/Login';
import MainPortal from './components/MainPortal';
import TextbookAnswers from './components/TextbookAnswers';
import PastPapers from './components/PastPapers';
import CommunityChat from './components/CommunityChat';
import UploadHub from './components/UploadHub';
import Profile from './components/Profile';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ResourceCategories from './components/ResourceCategories';
import ResourceCategory from './components/ResourceCategory';
import QuizPage from './components/QuizPage';
import { useEffect } from 'react';

function App() {
  const { isAuthenticated, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<Intro />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Routes>
        <Route path="/" element={<MainPortal />} />
        <Route path="/textbooks" element={<TextbookAnswers />} />
        <Route path="/past-papers" element={<PastPapers />} />
        <Route path="/community" element={<CommunityChat />} />
        <Route path="/upload" element={<UploadHub />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources" element={<ResourceCategories />} />
        <Route path="/resources/:categoryId" element={<ResourceCategory />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
